module.exports = __webpack_public_path__ + "img/icon_all.87f2468b.svg";